import React from 'react';
import styles from './Privacy.module.css';

const Privacy = () => {
  const pillars = [
    {
      title: 'No Account Required',
      desc: 'Skip the signup and start planning immediately. Open the app, set your profile, and generate your week without friction.',
    },
    {
      title: 'On-Device Storage',
      desc: "Your weight, age, schedule, and goals stay on your iPhone. We don't rely on a personal data warehouse to make the product work.",
    },
    {
      title: 'Zero Tracking',
      desc: 'We do not monetize your health habits. No invasive analytics, no data resale, and no hidden surveillance layer.',
    },
  ];

  return (
    <section className={styles.privacySection}>
      <div className={styles.container}>
        <div className={styles.headerBlock}>
          <span className={styles.kicker}>Privacy by Design</span>

          <h2 className={styles.heading}>
            Built for your body,
            <br />
            <span>not for Big Tech.</span>
          </h2>

          <p className={styles.intro}>
            LeanWeek takes a privacy-first approach to fitness planning. Your
            data stays close to you, the experience stays lightweight, and the
            product stays focused on helping you move.
          </p>
        </div>

        <div className={styles.grid}>
          {pillars.map((item, index) => (
            <article key={index} className={styles.card}>
              <div className={styles.cardTop}>
                <div className={styles.iconWrap}>
                  <div className={styles.iconGlow} />
                  <div className={styles.iconMark} />
                </div>
                <span className={styles.cardIndex}>
                  0{index + 1}
                </span>
              </div>

              <h3 className={styles.cardTitle}>{item.title}</h3>
              <p className={styles.cardDesc}>{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Privacy;